import { gatewayClient } from '../utils/gatewayClient';

export interface FetchEmployeeDetailsResponse {
  employee_details: {
    bank?: { account_number: string };
    reimbursement_method: string;
    address: {
      line1: string;
      line2: string;
      city: string;
      state: string;
      zip: string;
    };
  };
}
export function fetchEmployeeDetails() {
  return gatewayClient.get<FetchEmployeeDetailsResponse>('/cdh/v2/details');
}

export function updateReimbursementMethod({
  reimbursement_method,
}: {
  reimbursement_method: string;
}) {
  return gatewayClient.put('/cdh/v2/details', {
    reimbursement_method,
  });
}
